import React, { useState, useMemo, useCallback } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { MdDownload, MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from 'antd';
import { addTrack } from '../../store/actions/subscribeActions';

const StyledCollapse = styled.div`
  position: relative;
  & .collapse { /* CSS оставляем как есть */ }
`;

const CatalogTrackDownloadSelect = ({ trackId, downloadOpen = false }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(downloadOpen);
  const { subscribes } = useSelector((state) => state.user);

  const setOpenHandler = useCallback(() => setOpen((prev) => !prev), []);
  const downloadTrack = useCallback((subscribeId, type = 'mp3') => {
    dispatch(addTrack({ subscribeId, trackId, type }));
  }, [dispatch, trackId]);

  const subscribesWithTracks = useMemo(
    () => subscribes.filter(({ reservedCountTracks }) => reservedCountTracks > 0),
    [subscribes]
  );

  const hasSubscribes = subscribesWithTracks.length > 0;

  return (
    <StyledCollapse>
      {hasSubscribes ? (
        <a
          className="collapse__toggle button button--default waves-light button--waves button--success"
          onClick={setOpenHandler}
        >
          <span>Скачать по подписке</span>
          <span className="collapse__toggle--icon">
            {open ? <MdOutlineKeyboardArrowUp size={20} /> : <MdOutlineKeyboardArrowDown size={20} />}
          </span>
        </a>
      ) : (
        <Popover
          placement="topRight"
          content={<p style={{ fontSize: 16 }}>Вы можете приобрести подписку <br /> и скачивать треки выгодно!</p>}
        >
          <a className="collapse__toggle button button--default waves-light button--waves button--gray collapse__toggle_disabled">
            <span>Скачать по подписке</span>
          </a>
        </Popover>
      )}

      <div className="collapse__container">
        <Collapse isOpened={open}>
          <ul className="collapse__list">
            {subscribesWithTracks.map((sub) => (
              <li key={sub.id} className="my-2">
                <div className="d-flex justify-content-between">
                  <strong className="mr-1">{sub.typeSubscription}</strong>
                  <span className="collapse__text--mute">
                    Скачано <strong>{sub.freeCountTracks}</strong> из {sub.totalCountTracks}
                  </span>
                </div>
                <div className="d-flex align-content-center my-3">
                  <div className="collapse__button mr-2" onClick={() => downloadTrack(sub.id, 'wav')}>
                    <MdDownload /><span className="ml-1">WAV 16 bit</span>
                  </div>
                  <div className="collapse__button" onClick={() => downloadTrack(sub.id)}>
                    <MdDownload /><span className="ml-1">MP3 320 kbps</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Collapse>
      </div>
    </StyledCollapse>
  );
};

export default CatalogTrackDownloadSelect;
